import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class StockfishService {
  private stockfish: Worker;

  constructor() {
    this.stockfish = new Worker('assets/stockfish.js');
  }

  evaluatePosition(fen: string, depth?: number): Promise<string> {
    return new Promise((resolve, reject) => {
      this.stockfish.postMessage(`position fen ${fen}`);
      this.stockfish.postMessage(`go depth ${depth}`);

      this.stockfish.onmessage = (event) => {
        if (event.data.startsWith('bestmove')) {
          resolve(event.data.split(' ')[1]);
        }
      };

      this.stockfish.onerror = (error) => {
        reject(error);
      };
    });
  }
}
